<template>
  <div class="publications-by-source-content" :id="chartId">
    <div class="hidden-chart-name">
      {{title}} <b>{{charDateTitle}}</b>
    </div>
    <div class="chart-am5" ref="charttonal"></div>
    <a href="" :id="`download${chartId}`"></a>
  </div>
</template>

<script>
  // chart
  import { BarChart } from "../../../../../../../../components/charts";

  // actions
  import {SWITCH_ZERO} from "../../../../../../../../store/actions/analytics";

  // mixins
  import tonalPost from "../../../../../../../../mixins/chart/tonalPost";
  import saveImage from "../../../../../../../../mixins/saveImage";

  // config
  import tonal from "../../../../../../../../config/tonals";

  import * as am5 from '@amcharts/amcharts5';
  import * as am5xy from '@amcharts/amcharts5/xy';
  import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';

  // moment
  import moment from 'moment';

  // vuex
  import { mapGetters } from "vuex";

  export default {
    name: "PublicationsBySourceBody",
    props: {
      data: {
        type: Object,
        required: true
      },
      chartName: {
        type: String
      },
      saveChart: {
        type: Boolean,
        default: false
      },
      title: {
        type: String
      },
    },
    data() {
      return {
        tonal: this.$t('feed.analytics.tonalPost.body.tonal'),
        chartId: "TonalPost",
        format: "DD.MM.YYYY",
        showLabel: true,
        tonalItems: {
          netural: {
            name: 'netural',
            title: this.$t('feed.analytics.tonalPost.body.tonal[0].title'),
            position: "top",
            backgroundColor: "#b3bccc",
            borderColor: "rgba(0, 0, 0, 0)",
          },
          positive: {
            name: 'positive',
            title: this.$t('feed.analytics.tonalPost.body.tonal[1].title'),
            position: "bottom",
            backgroundColor: "#15cf49",
            borderColor: "rgba(0, 0, 0, 0)",
          },
          negative: {
            name: 'negative',
            title: this.$t('feed.analytics.tonalPost.body.tonal[2].title'),
            position: "top",
            backgroundColor: "#f75b5b",
            borderColor: "rgba(0, 0, 0, 0)",
          }
        },
        tonalArr: [],
      }
    },
    methods: {
      toggleLabel () {
        this.showLabel = !this.showLabel;
      },
          renderChart() {
        let root = am5.Root.new(this.$refs.charttonal);

        root.setThemes([am5themes_Animated.new(root)]);

        let chart = root.container.children.push(
          am5xy.XYChart.new(root, {
            panX: false,
            panY: false,
            wheelX: "panY",
            wheelY: "zoomY",
            paddingLeft: 0,
            layout: root.verticalLayout
          })
        );

        chart.set("scrollbarY", am5.Scrollbar.new(root, {
          orientation: "vertical"
        }));

        chart.set("colors", am5.ColorSet.new(root, {
          colors: [
            am5.color("#6fd267"),
            am5.color("#f75b5b"),
            am5.color("#b3bccc")
          ]
        }))


        // Define data
        let data = this.dataBarCollection.databylables
        console.log("dsdsds", this.data)
        console.log("www", this.dataBarCollection)
        

        var yRenderer = am5xy.AxisRendererY.new(root, {});
        var yAxis = chart.yAxes.push(am5xy.CategoryAxis.new(root, {
          categoryField: "category",
          renderer: yRenderer,
        }));

        yRenderer.grid.template.setAll({
          location: 1
        })
        

        yAxis.data.setAll(data);

        var xAxis = chart.xAxes.push(am5xy.ValueAxis.new(root, {
          min: 0,
          maxPrecision: 0,
          renderer: am5xy.AxisRendererX.new(root, {
            minGridDistance: 40,
            strokeOpacity: 0.1
          })
        }));

        var label1 = am5.Label.new(root, {
          text: "Количество",
          y: am5.p0,
          x: am5.p50,
        })

        xAxis.children.unshift(
          label1
        );

function createSeries(field, name) {
  let series = chart.series.push(am5xy.ColumnSeries.new(root, {
    name: name,
    stacked: true,
    xAxis: xAxis,
    yAxis: yAxis,
    valueXField: field,
    categoryYField: "category",
    //sequencedInterpolation: true,
    /*tooltip: am5.Tooltip.new(root, {
      pointerOrientation: "vertical",
      labelText: "[bold]{categoryX}[/]\n{name}: {valueY}"
    })*/
  }));

  series.columns.template.setAll({
    tooltipText: "{name}, {categoryY}: {valueX}",
    tooltipY: am5.percent(90)
  });


  series.bullets.push(function () {
      let totalLabel = am5.Label.new(root, {
        centerX: am5.p0,
        centerY: am5.p50,
        text: "{valueX}",
        textAlign: "center",
        fill: root.interfaceColors.get("text"),
        populateText: true
      })

      totalLabel.adapters.add("text", function(text, target) {
        var dataContext = target.dataItem.dataContext;
        //var val = dataContext.total.toString() + text.toString()[0];
        var val = (target.dataItem.get("valueX") * 100) / dataContext.total;
        return val.toFixed(2) + '%';
      });

      return am5.Bullet.new(root, {
        sprite: totalLabel
      });

    });


  series.data.setAll(data);
  series.appear();

  return series;
}

        createSeries("positive", "Позитивные", "total");
        createSeries( "negative", "Негативные", "total");
        createSeries("netural","Нейтральные", "total");

        /*yAxis.axisHeader.children.push(am5.Label.new(root, {
          text: "Volume",
          fontWeight: "500"
        }));

        var legend = yAxis.axisHeader.children.push(am5.Legend.new(root, {}));
          legend.data.setAll(chart.series.values);*/
        
        // Add legend
        let legend = chart.children.push(am5.Legend.new(root, {
          centerX: am5.p50,
          x: am5.p50
        }));
        legend.data.setAll(chart.series.values);

        // Add cursor
        chart.set("cursor", am5xy.XYCursor.new(root, {}));

        this.root = root;
      },
    },
    watch: {
      data: {
        handler(val, oldVal) {
          console.log('1')
          if(!!this.root) this.root.dispose()
          this.renderChart();
          console.log('11')
        },
        deep: true
      },
    },
    computed: {
      ...mapGetters([
        "socialList",
      ]),
      showZeroData: {
        get() {
          return this.$store.getters.getZeroData(this.chartName);
        },
        set(value) {
          this.$store.dispatch(SWITCH_ZERO, {chart: this.chartName, isZero: value})
        }
      },
      chartDate() {
        return this.$store.getters.getPeriod(this.chartName);
      },
      charDateTitle () {
        return `${moment(this.chartDate[0]).format(this.format)} - ${moment(this.chartDate[1]).format(this.format)}`;
      },
      isLoaded() {
        return this.$store.getters.isLoaded(this.chartName);
      }
    },
    mixins: [
      tonalPost,
      saveImage
    ],
    components: {
      BarChart
    },
    mounted() {
      //if(!!this.root) this.root.dispose()
      console.log('0', this.data)
      //this.renderChart()
    },
    beforeMount() {
      console.log('0', this.data)
        console.log('00')
    },
      beforeDestroy() {
        this.root.dispose();
    }
  };
</script>

<style>
  @import "../../../../../../../../style/tonal.css";
  .publications-by-source-content__chart {
    margin-bottom: 10px;
  }

  .axes-title {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
    padding: 0 0 10px 0;
    color: #5E6D82;
  }
  .chart-show-labels {
    display: flex;
    justify-content: start;
    padding: 20px 10px;
    font-size: 16px;
  }
</style>
